<template>
  <div class="layout-default_header" id="siteHeader">
    <site-logo />
    <div class="header-sp">
      <layout-header-sp />
    </div>
    <div class="header-pc">
      <nav class="layout-default_nav">
        <ul>
          <li>
            <router-link :to="{ name: 'PageIndex' }">Top</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'PageAbout' }">About</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'PageSkills' }">Skills</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'PageWorks' }">Works</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'PageContact' }">Contact me</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import LayoutHeaderSp from './HeaderSp';

export default {
  components: {
    LayoutHeaderSp
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/default/Header.vue